module.exports = __webpack_public_path__ + "media/images/home/en/preview-7-a18f12fa885897cd83091250fd99705f.jpg";